export const LottieConfig = {
  errorAnimation: {
    path: 'https://lottie.host/9f008344-b70b-4309-8de5-2ec9ee4e0be9/fqkj3DgttX.json',
  },

  contactSalesAnimation: {
    path: 'https://lottie.host/c2c5a12d-ab07-4784-b65a-7c8a2bd12260/Ct5mABLIxB.json',
  },
};
